import { APIProvider } from "@vis.gl/react-google-maps"
import React, { useEffect, useState } from "react"

const GOOGLE_MAPS_BASE_URL = "https://maps.googleapis.com/maps/api/js"

function loadGoogleMaps(locale: string, apiKey: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      "script[src^='https://maps.googleapis.com/maps/api/js']",
    )

    // Remove old script
    if (existingScript) {
      existingScript.remove()
      delete (window as any).google
    }

    const script = document.createElement("script")
    script.src = `${GOOGLE_MAPS_BASE_URL}?key=${apiKey}&language=${locale}&libraries=places`
    script.async = true
    script.defer = true

    script.onload = () => {
      resolve()
    }
    script.onerror = (err) => {
      reject(err)
    }

    document.head.appendChild(script)
  })
}

type MapLocaleProviderProps = {
  locale: string
  apiKey: string
  children: React.ReactNode
}

export default function MapLocaleProvider({ locale, apiKey, children }: MapLocaleProviderProps) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    setReady(false)
    loadGoogleMaps(locale, apiKey)
      .then(() => {
        setReady(true)
      })
      .catch((err) => {
        console.error("Google Maps failed to load", err)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale])

  if (!ready) return null

  return (
    <APIProvider language={locale} apiKey={apiKey}>
      {children}
    </APIProvider>
  )
}
